import { render, staticRenderFns } from "./BrowserChartArc.vue?vue&type=template&id=745435b4&scoped=true&"
import script from "./BrowserChartArc.vue?vue&type=script&lang=js&"
export * from "./BrowserChartArc.vue?vue&type=script&lang=js&"
import style0 from "./BrowserChartArc.vue?vue&type=style&index=0&id=745435b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745435b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VCardTitle,VIcon})
